export default __webpack_public_path__ + "static/media/role-icon.d8cead16.svg";